import "./containers.css";

const PixelRainContainer = ({ children, style, className }) => {
  return (
    <div
      style={style}
      className={"pixel-rain" + (className ? " " + className : "")}
    >
      {children}
    </div>
  );
};

export { PixelRainContainer };
